import { render, staticRenderFns } from "./customOrdonnance.vue?vue&type=template&id=138c8068&scoped=true"
import script from "./customOrdonnance.vue?vue&type=script&lang=js"
export * from "./customOrdonnance.vue?vue&type=script&lang=js"
import style0 from "./customOrdonnance.vue?vue&type=style&index=0&id=138c8068&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138c8068",
  null
  
)

export default component.exports